import { render, staticRenderFns } from "./TaskReviewDialog.vue?vue&type=template&id=5a969d06&scoped=true&"
import script from "./TaskReviewDialog.vue?vue&type=script&lang=js&"
export * from "./TaskReviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./TaskReviewDialog.vue?vue&type=style&index=0&id=5a969d06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a969d06",
  null
  
)

export default component.exports